import { render } from "./LoadingLayout.vue?vue&type=template&id=2d9efcaa"
import script from "./js/loadingLayout.js?vue&type=script&lang=js&external"
export * from "./js/loadingLayout.js?vue&type=script&lang=js&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__